const scrollLink = () => {
  const scrollHandler = (event) => {
    event.preventDefault();

    const currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
    const targetElementId = event.currentTarget.getAttribute('href').split('#')[1];
    if (!targetElementId) return;
    const goToPosition = document.getElementById(targetElementId).offsetTop;
    const distance = goToPosition - currentPosition;

    const totalStep = 40;
    let currentStep = 0;
    const intervalTime = 10;

    const scrollby = distance / totalStep;

    const isScrollElementBody = document.scrollingElement && document.scrollingElement.tagName == 'BODY';

    const interval = setInterval(function () {
      if (currentStep < totalStep) {
        isScrollElementBody ? (document.body.scrollTop += scrollby) : (document.documentElement.scrollTop += scrollby);
        currentStep++;
      } else {
        clearInterval(interval);
      }
    }, intervalTime);
  };

  var scrollLinks = document.querySelectorAll('.scrollTo');
  for (var i = 0; i < scrollLinks.length; i++) {
    scrollLinks[i].addEventListener('click', scrollHandler);
  }
};

export default scrollLink;
